import axios from 'axios'
import Swal from 'sweetalert2'
import { queryClient } from '../../..';

export default function putUploadArquivo(
  url: any,
  arquivo: any,
  ClienteId: number,
  onSuccess: () => void,
) {
  return axios.put(url, arquivo.file,{
    headers: {
      'Content-Type': `application/${arquivo.mimeType}`,
      'x-ms-blob-type' : 'BlockBlob',
      'x-ms-meta-Nome' : `${arquivo.nome}`,
      'x-ms-tags' : `ClienteId=${ClienteId}&Type=${arquivo.mimeType}`
    },
  })
  .then((response) => {
    Swal.fire({
      title: 'Sucesso',
      text: 'Upload realizado com sucesso!',
      icon: 'success',
      position: 'center',
      confirmButtonText: 'Ok',
      confirmButtonColor: '#349946',
      allowOutsideClick: false
    }).then(response => {
      if (response.isConfirmed) {
        onSuccess();
        queryClient.invalidateQueries();
      }
    })
  })
  .catch((err) => {
    Swal.fire({
      title: 'Ocorreu um erro',
      text: err.response.data.message,
      icon: 'error',
      position: 'center',
      confirmButtonText: 'Ok',
      confirmButtonColor: '#F27474',
      allowOutsideClick: false
    })
  })
}